import CommercialControl from './commercial/CommercialControl';
import { useCommercialControl } from './commercial/useCommercialControl';
import { useProjectId } from 'domain/shared/project';
import ProjectManagementControl from './projectManagement/ProjectManagementControl';
import EngineeringControl from './engineering/EngineeringControl';
import StaffingControl from './staffing/StaffingControl';
import { Loading } from 'framework/ui/mui-builder';

const ViewControlsLayout = () => {
  const projectId = useProjectId();
  const { data, loading, refetchCommercialData, refetchProjectManagementData, refetchEngineeringData } =
    useCommercialControl(projectId);

  if (loading) return <Loading isInitialPosition />;
  if (!data) return null;

  return (
    <>
      <CommercialControl data={data} refetchControlsData={refetchCommercialData} />
      <ProjectManagementControl data={data} refetchControlsData={refetchProjectManagementData} />
      <EngineeringControl data={data} refetchControlsData={refetchEngineeringData} />
      <StaffingControl data={data} />
    </>
  );
};

export default ViewControlsLayout;
